import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
var AuxUrlInfTerComponent = /** @class */ (function () {
    function AuxUrlInfTerComponent(dialog, _router) {
        this.dialog = dialog;
        this._router = _router;
        this.mapasUrl = GLOBAL.mapasUrl;
        this.acotado = GLOBAL.acotado;
    }
    AuxUrlInfTerComponent.prototype.ngOnInit = function () {
    };
    return AuxUrlInfTerComponent;
}());
export { AuxUrlInfTerComponent };
